<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="obj.title" :headText="obj.content"></titleHead>
    <div class="technology_content warp">
      <div class="technology_item">
        <div>
          <div class="technology_search_criteria" >
            <span class="technology_search_tips">{{categoryList_0.name}}:</span>
            <ul>
              <li
                v-for="(row, i) in categoryList_0.children"
                :key="i"
                :class="currentChildren == i ? 'active' : ''"
                @click="rowChanges(row, i)"
              >
                <span >{{ row.name }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <div class="technology_search_criteria" >
            <span class="technology_search_tips" >{{ categoryList_1.name }}:</span>
            <ul>
              <li
                v-for="(item, index) in categoryList_1.children"
                :key="index"
                :class="current == index ? 'actives' : ''"
                @click="rowChange(item, index)"
              >
                <span >{{ item.name }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="search_input">
          <input
            type="text"
            v-model="keyword"
            placeholder="请输入你要查询的关键字"
            @keyup.enter="getTechnologyList"
          />
          <button @click="getTechnologyList">
            <img src="../../assets/images/search.png" alt="" />
          </button>
        </div>
        <div class="search_keywords">
          <span>关键字:</span>
          <a
            @click="setKeyword(item)"
            v-for="(item, index) in categoryList_2 && categoryList_2.children"
            :key="index"
            :href="item.link"
            target="_blank"
            >{{ item.name }}</a>
        </div>
        <newsList :list="technologyList"></newsList>
        <Pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.curPage"
          :limit.sync="listQuery.limit"
          @pageChange="pageChange"
        ></Pagination>
      </div>

      <div class="technology_recommend">
        <!--推荐阅读-->
        <newsRecom
          :newsRecommendObj="newsRecommendObj"
          @dataRefresh ="getTechnoList(4)"
          urlType="technology_detail"
        ></newsRecom>
        <div class="find_right" v-if="advList.length>0">
          <a :href="'//'+advList[0].url" target="_blank">
            <img :src="advList[0].image" alt="" />
            <span>广告</span>
          </a>
        </div>
        <!--采购指南-->
        <newsRecom :newsRecommendObj="newsRecommendObj2" @dataRefresh="getGuideList(5)"  urlType="info_detail"></newsRecom>
        <!--推荐企业-->
        <newRecommImg
          v-if="companyList.length > 0"
          class="mt-10"
          :list="companyList"
          @reload="randomCompany(4)"
        ></newRecommImg>
      </div>
    </div>
  </div>
</template>

<script>
import {getDict} from "@/api/coment"
import { getRandomArray } from "@/utils/index";
import {
  getTechnologyList,
  getCompanyList,
  getAdv,
  getIndustryinfoList
} from "@/api/information";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import newsRecom from "../../common/newsRecom";
import newsList from "../../components/newsList";
import newRecommImg from "../../common/newRecommImg";
import Pagination from "../../components/Pagination";
import { getDictList } from '../../api/information';
export default {
  components: {
    commBanner,
    titleHead,
    newsRecom,
    newsList,
    newRecommImg,
    Pagination,
  },
  provide: {
    urlType: "technology_detail",
  },
  data() {
    return {
      obj: {
        title: "环保技术",
        roleType:'',
        personalType:2,
      },
      categoryList_0:[],
      categoryList_1:[],
      categoryList_2:[],
      categoryList: [],
      industry_type:"",
      technologyList: [],
      allList: [], //推荐阅读
      current: 0,
      currentChildren: 0,
      listQuery: {
        curPage: 1,
        limit: 5,
      },
      keyword: undefined,
      category: undefined,
      total: 0,
      newsRecommendObj: {
        title: "推荐阅读",
        text: "换一批",
        isImg: true,
        newData: [],
      },
      newsRecommendObj2: {
        title: "采购指南",
        text: "换一批",
        isImg: false,
        newData: [],
      },
      companyAllList: [],
      companyList: [],
      advType: 4,
      advList: [],
      label:'',
      guideList:[]
    };
  },
  created() {
    this.getTechnologyList();
    this.getRecommendTechnologyList();
    this.getCompanyList();
    this.getAdv();
    this.getCailter();
    this.getIndustryinfoList();
    if(this.$store.state.user.userInfo != null){
      let type = this.$store.state.user.userInfo.type;
      this.obj.roleType = type;
    }
  },
  computed:{
     dictList(){
       return this.$store.state.industry.list;
     }
  },
  methods: {
    //获取分类
     getCailter() {
      let that=this;
      let params = {code: this.industry_type};
      getDictList()
        .then((res) => {
          if (res.code == 0) {
            res.data.forEach((element,index) => {
              if(0==index){
                that.categoryList_0=element;
              }else if(4==index){
                that.categoryList_1=element;
              }else if(2==index){
                that.categoryList_2= element;
              }
            });

          }
        })
        .catch((err) => {});
     },

    //获取广告
    getAdv() {
      getAdv({
        curPage: 1,
        limit: 10,
        type: this.advType,
      }).then((res) => {
        if(res.code == 0){
          this.advList = res.page.list;
        }
      });
    },
    setKeyword(item) {
      // this.keyword = item.name;
    },
    //查询推荐企业
    getCompanyList() {
      getCompanyList({
        recommend: 1,
      }).then((res) => {
        if(res.code ==0){
          this.companyAllList = res.data.list;
          this.randomCompany(4);
        }
      });
    },
    randomCompany(length) {
      this.companyList = _.compact(getRandomArray(_.cloneDeep(this.companyAllList), length));
    },
	 //获取列表
    getTechnologyList() {
      getTechnologyList({
        category: this.category,
        curPage: this.listQuery.curPage,
        keyword: this.keyword,
        limit: this.listQuery.limit,
        label: this.label.toString(),
      }).then((res) => {
        if(res.code ==0){
          const { page } = res;
          this.technologyList = page.list;
          this.total = page.totalCount;
          this.getMate(this.technologyList)
        }
      });
    },
    //获取推荐技术内容 前端随机取4个
    getRecommendTechnologyList() {
      getTechnologyList({
        recommend: 1,
      }).then((res) => {
        if(res.code == 0 ){
          this.allList = res.page.list;
          this.getTechnoList(4)
        }
      });
    },
    getTechnoList(length) {
      this.newsRecommendObj.newData =  _.compact(getRandomArray(_.cloneDeep(this.allList), length));
    },

    //采购指南
    getIndustryinfoList(){
      getIndustryinfoList({
        cgroup:1,
        curPage:1,
        limit:10
      }).then((res)=>{
        if(res.code == 0){
           this.guideList = res.page.list;
           this.getGuideList(5)
        }
      }).catch((err)=>{})
    },
    
     getGuideList(length){
       this.newsRecommendObj2.newData =  _.compact(getRandomArray(_.cloneDeep(this.guideList), length));
     },

    //分页
    pageChange(item) {
      this.listQuery["curPage"] = item.page;
      this.listQuery["limit"] = item.limit;
      this.getTechnologyList();
    },
    rowChanges(row, i) {
      this.currentChildren = i;
      this.category = row.id;
      this.getTechnologyList();
    },
    rowChange(item, index) {
      this.current = index;
      this.label = item.id;
      if(!item){
        this.label =''
      }
      this.getTechnologyList();
    },
    //seo
    getMate(data){
      var metas = document.getElementsByTagName("meta");
      metas[0].name ="keyword"
      if(data[0] && data[0].seokeywords ){
        metas[0].content= data[0].seokeywords
      }
      metas[1].name ="description"
      metas[1].content=data[0].seodescription
      document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
      // document.getElementsByTagName("title")[0].innerText= data[0].title +'_智污邦环保服务平台';
    }
  },
};
</script>

<style scoped lang="less">
.page {
  text-align: center;
  margin-top: 40px;
}
.technology_content {
  display: flex;
  .technology_item {
   width: 70%;
    margin-bottom: 40px;
    margin-right: 30px;
    .technology_search_criteria {
      display: flex;
      align-items: center;
      border-bottom: 1px dashed #e1e1e1;
      border-top: 1px dashed #e1e1e1;
      &:nth-of-type(2) {
        border-top: none;
      }
      .technology_search_tips {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-right: 20px;
      }
      ul {
        display: flex;
        padding: 5px 0;
        li {
          width: 70px;
          text-align: center;
          cursor: pointer;
          margin-right: 20px;
          padding: 5px 0;
          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }
        }
        .active {
          transition: all 0.5s;
          background: #3bae30;
          border-radius: 3px;
          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            padding: 5px 0;
          }

        }
        .actives {
          transition: all 0.5s;
          background: #3bae30;
          border-radius: 3px;
          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            padding: 5px 0;
          }

        }
      }
    }
    .search_input {
      display: flex;
      margin-top: 25px;
      input {
        flex: 7;
        border: 1px solid #65b62b;
        border-right: none;
        padding: 16px;
      }
      button {
        padding: 0 34px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        background: #3bae30;
        img {
          width: 21px;
          height: 21px;
        }
      }
    }
    .search_keywords {
      margin-top: 5px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      span {
        margin-right: 10px;
        cursor: pointer;
        &:first-of-type {
          margin-right: 0;
        }
      }
      a{
         color: #999999 !important;
         padding-right: 15px;
      }
    }
  }
  .technology_recommend {
    // flex: 3;
    width: 27%;
  }
}
.find_right {
  margin-top: 10px;
  position: relative;
  margin-bottom: 10px;
}
.find_right img {
  width: 100%;
  height: 184px;
}
.find_right span {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.mt-10 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/technology/technology.vue